/**
 * modules
 */

import preloader from '../../../templates/_atoms/preloader/_script';
import codeSnippet from '../../../templates/_atoms/codeSnippet/_script';
import imageSlider from '../../../templates/_organisms/imageSlider/_script';
import imageGallery from '../../../templates/_organisms/imageGallery/_script';
import appHeader from '../../../templates/_organisms/appHeader/_script';
import newsList from '../../../templates/_organisms/newsList/_script';
import pageTitle from '../../../templates/_organisms/pageTitle/_script';
import weather from '../../../templates/_organisms/weather/_script';
import imageTrack from '../../../templates/_organisms/imageTrack/_script';
import calendarList from '../../../templates/_organisms/calendarList/_script';
import richText from '../../../templates/_atoms/richText/_script';
import faqList from '../../../templates/_molecules/faqList/_script';
// import dataItem from '../../../templates/_molecules/dataItem/_script';
// import accordion    from '../../../templates/_templates/accordion/_main'
// import cookiebar    from '../../../templates/_modules/cookiebar/_main'
// import imageSlider  from '../../../templates/_modules/imageSlider/_main'
// import imageGallery from '../../../templates/_modules/imageGallery/_main'
// import navCategories from '../../../templates/_modules/navCategories/_main'

// Modules Array
const modulesArray = [
    preloader,
    codeSnippet,
    imageSlider,
    imageGallery,
    appHeader,
    newsList,
    pageTitle,
    weather,
    imageTrack,
    calendarList,
    richText,
    faqList,
    // dataItem,
    // accordion,
    // cookiebar,
    // imageGallery,
    // navCategories
];

const modules = {
    // Modules
    Modules() {
        if (modulesArray.length > 0 && modulesArray !== undefined) {
            modulesArray.forEach((module) => {
                module.init();
            });
        }
    },

    init() {
        this.Modules();
    }
};

export default modules;



// WEBPACK FOOTER //
// ./___src/assets/js/partials/modules.js